<template>
  <div class="search-heading" v-if="shouldShow">
    <h1>{{ formSearchHeading }}</h1>
  </div>
</template>

<script setup lang="ts">
import { areWeInSearchPage } from '@/app/routes';
import utils from '@/app/utils/utils';
import config from '@/config';
import { getFeatureGroupById } from '@/config/featureGroups';
import cities from '@/utils/cities';
import useSafeRoute from '@/app/composables/useSafeRoute';
import { computed } from 'vue';

const route = useSafeRoute();

const props = defineProps<{
  filters: {
    mode?: string;
    featureGroup?: string;
  };
}>();

const shouldShow = computed(() => areWeInSearchPage(route.value.path));

const formSearchHeading = computed(() => {
  const modePart = props.filters.mode === config.SEARCH_MODES.RENTAL ? 'Vuokrattavat' : 'Myytävät';
  const typePart = getFeatureGroupById(props.filters.featureGroup)?.name.toLowerCase() ?? '';

  const pathParts = utils.splitPathToParts(route.value.path);
  const cityInUrl = pathParts.length === 3 && pathParts[2].length ? pathParts[2] : '';
  const cityToShow = cities.find((city: any) => utils.nameToPathFormat(city.name) === cityInUrl)?.name;

  return `${modePart} ${typePart} ${cityToShow ? ` - ${cityToShow}` : ''}`;
});
</script>
